export { MsalTokenHttpAuthenticationProvider } from './msalTokenHttpAuthenticationProvider';